import {Component, OnInit, Input} from '@angular/core';
import {Device} from '../../../../../models/device';
import {DataStorageService} from '../../../../data-storage.service';
import {ConfigService} from '../../../../config.service';
import {ApiService} from '../../../../api.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss']
})
export class DeviceComponent implements OnInit {

  @Input() device: Device;
  @Input() i: number;

  constructor(public dataStorageService: DataStorageService,
              public configService: ConfigService,
              public api: ApiService,
              public router: Router) {
  }

  ngOnInit() {
  }

  editDevice(dev: Device) {
    this.dataStorageService.from = 'EDIT';
    this.dataStorageService.editedDevice = dev;
    this.router.navigate(['/editManagement']);
  }

  removeDevice(deviceID: number, index: number) {
    const result = confirm('Are you sure to delete?');
    if (result) {
      this.api.deleteDevice(deviceID).then(() => {
        this.dataStorageService.devices.splice(index, 1);
      });
    }
  }

  calculateMargin(dev: Device) {
    const calculated = ( 1 - (dev.purchasePrice / dev.salePrice) ) * 100;
    return calculated;
  }

  changeVisible(device: Device, i: number) {
    const visibleStatus = !device.visible;
    this.api.putVisible(device.id, visibleStatus).then(() => {
      this.dataStorageService.devices[i].visible = visibleStatus;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/content/management/device-list/device/device.component.ts